(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aw-subscription-wizard"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aw-subscription-wizard')) {
  customElements.define('aw-subscription-wizard', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.t = this.config.text;
      this.root = this.config.root.replace(/\/?$/, '/');
      this.dialog = this.querySelector('dialog');
      this.content = this.querySelector('[data-content]');
      this.message = this.querySelector('[data-message]');
      this.next = this.querySelector('[data-next]');
      this.back = this.querySelector('[data-back]');
      this.step = 0;
      this.products = [];
      this.filter = 'all';
      this.busy = false;
      this.uncertain = false;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.openHandler = event => {
        const anchor = event.target.closest('[data-aw-subscription]');
        if (!anchor || !this.closest('.t4s-feature-columns')?.contains(anchor)) return;
        event.preventDefault();
        this.opener = anchor;
        this.dialog.showModal();
        if (!this.products.length) this.load(); else this.render();
      };
      document.addEventListener('click', this.openHandler, {signal});
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), {signal});
      this.dialog.addEventListener('close', () => this.opener?.focus(), {signal});
      this.back.addEventListener('click', () => { if (!this.busy && this.step > 0) { this.step--; this.render(); } }, {signal});
      this.next.addEventListener('click', () => {
        if (this.busy || this.uncertain || this.added) return;
        if (this.step === 3) { this.checkout(); return; }
        if (!this.selectionValid()) { this.message.textContent = this.t.select; return; }
        this.step++;
        this.render();
      }, {signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
    el(tag, text, className) {
      const node = document.createElement(tag);
      if (text !== undefined && text !== null) node.textContent = text;
      if (className) node.className = className;
      return node;
    }
    money(value) {
      return new Intl.NumberFormat(this.config.locale, {style:'currency',currency:this.config.currency}).format(value / 100);
    }
    async productFetch(url) {
      const response = await fetch(url + '.js', {headers:{Accept:'application/json'}, signal:AbortSignal.timeout(15000)});
      if (!response.ok) throw new Error('product');
      return response.json();
    }
    plans(product) {
      return product.selling_plan_groups.filter(group => group.app_id === 'appstle').flatMap(group => group.selling_plans).filter(plan => plan.recurring_deliveries);
    }
    allocations(product, variant) {
      const ids = new Set(this.plans(product).map(plan => Number(plan.id)));
      return (variant.selling_plan_allocations || []).filter(allocation => ids.has(Number(allocation.selling_plan_id)));
    }
    variants(product) { return product.variants.filter(variant => variant.available && this.allocations(product, variant).length); }
    planName(plan) {
      const name = plan.name.trim().toLowerCase();
      if (['monthly','cada mes','every month'].includes(name)) return this.t.monthly;
      if (['cada 2 meses','every 2 months'].includes(name)) return this.t.two_months;
      if (['cada 3 meses','every 3 months'].includes(name)) return this.t.three_months;
      return plan.name;
    }
    async load() {
      this.busy = true;
      this.content.replaceChildren(this.el('p', this.t.loading));
      this.next.disabled = true;
      this.back.hidden = true;
      this.message.textContent = '';
      try {
        const results = await Promise.allSettled(this.config.catalog.map(item => this.productFetch(item.url)));
        if (results.some(result => result.status === 'rejected')) throw new Error('catalog');
        this.products = results.map(result => result.value).filter(product => this.variants(product).length);
        this.busy = false;
        if (!this.products.length) {
          this.content.replaceChildren(this.el('p', this.t.no_products), this.browseLink());
          return;
        }
        this.render();
      } catch {
        this.busy = false;
        this.content.replaceChildren(this.el('p', this.t.load_error));
        const retry = this.el('button', this.t.retry, 'aws-next');
        retry.type = 'button';
        retry.addEventListener('click', () => this.load());
        this.content.append(retry, this.browseLink());
      }
    }
    browseLink() {
      const link = this.el('a', this.t.browse, 'aws-small');
      link.href = this.root + 'collections/scents-1';
      return link;
    }
    image(product, className) {
      const image = this.el('img', null, className);
      image.src = (product.featured_image || '').replace(/^\/\//, 'https://');
      image.alt = product.title;
      image.width = 300;
      image.height = 300;
      image.loading = 'lazy';
      return image;
    }
    price(allocation, variant, from = false) {
      const wrap = this.el('div');
      const price = this.el('span', null, 'aws-price');
      const compare = allocation.compare_at_price || variant.price;
      if (compare > allocation.price) price.append(this.el('del', this.money(compare)));
      price.append(document.createTextNode((from ? this.t.from + ' ' : '') + this.money(allocation.price)));
      wrap.append(price, this.el('span', this.t.per_delivery, 'aws-small'));
      if (compare > allocation.price) wrap.append(this.el('span', this.t.save.replace('{percent}', String(Math.round((1 - allocation.price / compare) * 100))), 'aws-badge'));
      return wrap;
    }
    card(name, id, title, checked, onSelect) {
      const label = this.el('label', null, 'aws-card');
      const radio = this.el('input');
      radio.type = 'radio';
      radio.name = name;
      radio.value = String(id);
      radio.checked = checked;
      radio.addEventListener('change', () => { onSelect(); this.next.disabled = !this.selectionValid(); this.message.textContent = ''; });
      label.append(radio, this.el('span', title, 'aws-name'));
      return label;
    }
    selectionValid() {
      if (this.step === 0) return Boolean(this.product);
      if (this.step === 1) return Boolean(this.variant);
      if (this.step === 2) return Boolean(this.allocation);
      return Boolean(this.content.querySelector('[data-consent]')?.checked);
    }
    render() {
      const keys = ['scent','size','frequency','review'];
      this.message.textContent = '';
      this.content.replaceChildren();
      this.querySelector('[data-step-count]').textContent = this.t.step.replace('{current}', String(this.step + 1));
      this.querySelectorAll('.aws-progress span').forEach((node, i) => node.classList.toggle('is-active', i <= this.step));
      const heading = this.querySelector('[data-question]');
      heading.textContent = this.t[keys[this.step] + '_question'];
      this.querySelector('[data-help]').textContent = this.t[keys[this.step] + '_help'];
      this.back.hidden = this.step === 0;
      this.back.disabled = this.busy || this.uncertain || this.added;
      this.next.textContent = this.step === 3 ? this.t.checkout : this.t.next;
      if (this.uncertain || this.added) {
        this.message.textContent = this.uncertain ? this.t.uncertain : this.t.added;
        this.content.append(this.cartLink());
        this.next.disabled = true;
        return;
      }
      if (this.step === 0) this.renderScents();
      if (this.step === 1) this.renderSizes();
      if (this.step === 2) this.renderFrequency();
      if (this.step === 3) this.renderReview();
      this.next.disabled = !this.selectionValid() || this.busy;
      heading.focus({preventScroll:true});
      this.dialog.scrollTop = 0;
    }
    renderScents() {
      const filters = this.el('div', null, 'aws-filters');
      for (const family of ['all','fresh','warm','floral']) {
        const button = this.el('button', this.t[family], 'aws-filter');
        button.type = 'button';
        button.setAttribute('aria-pressed', String(this.filter === family));
        button.addEventListener('click', () => { this.filter = family; this.product = null; this.variant = null; this.allocation = null; this.render(); });
        filters.append(button);
      }
      this.content.append(filters);
      const families = {'enigma-scent':'fresh','dreamy-scent':'fresh','elixir-scent':'warm','temptation-scent':'warm','seduction-scent':'floral','utopia-scent':'floral','eleganza':'floral'};
      const grid = this.el('div', null, 'aws-grid');
      this.products.filter(product => this.filter === 'all' || families[product.handle] === this.filter).forEach(product => {
        const card = this.card('aws-scent', product.id, product.title, this.product?.id === product.id, () => { this.product = product; this.variant = null; this.allocation = null; });
        card.insertBefore(this.image(product), card.lastChild);
        const notes = this.t[product.handle.replace(/-scent$/, '')];
        if (notes) card.append(this.el('span', notes, 'aws-notes'));
        const choices = this.variants(product).flatMap(variant => this.allocations(product, variant).map(allocation => ({variant, allocation})));
        choices.sort((a,b) => a.allocation.price - b.allocation.price);
        card.append(this.price(choices[0].allocation, choices[0].variant, true));
        grid.append(card);
      });
      this.content.append(grid);
    }
    renderSizes() {
      const grid = this.el('div', null, 'aws-grid aws-grid--options');
      [...this.product.variants].sort((a,b) => parseFloat(a.title) - parseFloat(b.title)).forEach(variant => {
        const allocations = this.allocations(this.product, variant);
        const available = variant.available && allocations.length;
        const card = this.card('aws-size', variant.id, variant.title, this.variant?.id === variant.id, () => { this.variant = variant; this.allocation = null; });
        if (!available) {
          card.querySelector('input').disabled = true;
          card.append(this.el('span', this.t.unavailable, 'aws-small'));
        } else {
          const cheapest = [...allocations].sort((a,b) => a.price - b.price)[0];
          card.append(this.price(cheapest, variant, allocations.length > 1));
        }
        grid.append(card);
      });
      this.content.append(grid);
    }
    renderFrequency() {
      const grid = this.el('div', null, 'aws-grid aws-grid--options');
      const plans = this.plans(this.product);
      for (const allocation of this.allocations(this.product, this.variant)) {
        const plan = plans.find(item => Number(item.id) === Number(allocation.selling_plan_id));
        const card = this.card('aws-frequency', plan.id, this.planName(plan), this.allocation?.selling_plan_id === allocation.selling_plan_id, () => { this.allocation = allocation; });
        card.append(this.price(allocation, this.variant));
        grid.append(card);
      }
      this.content.append(grid, this.el('p', this.t.recurring, 'aws-terms'));
    }
    renderReview() {
      const plan = this.plans(this.product).find(item => Number(item.id) === Number(this.allocation.selling_plan_id));
      const card = this.el('div', null, 'aws-review');
      const detail = this.el('div');
      detail.append(this.el('strong', this.product.title, 'aws-name'));
      const list = this.el('dl');
      for (const [label,value] of [[this.t.size,this.variant.title],[this.t.frequency,this.planName(plan)]]) list.append(this.el('dt',label), this.el('dd',value));
      detail.append(list, this.price(this.allocation,this.variant), this.el('span', this.t.bottle, 'aws-small'));
      card.append(this.image(this.product),detail);
      const terms = this.el('p', this.t.recurring, 'aws-terms');
      const policy = this.el('a', this.t.policy, 'aws-small');
      policy.href = this.config.catalog.find(item => item.handle === this.product.handle).url + '?variant=' + this.variant.id + '&selling_plan=' + this.allocation.selling_plan_id;
      policy.target = '_blank';
      policy.rel = 'noopener';
      const consent = this.el('label', null, 'aws-consent');
      const checkbox = this.el('input');
      checkbox.type = 'checkbox';
      checkbox.dataset.consent = '';
      checkbox.addEventListener('change', () => { this.next.disabled = !checkbox.checked || this.busy; });
      consent.append(checkbox,this.el('span',this.t.consent));
      this.content.append(card, this.el('p',this.t.shipping,'aws-small'), terms, policy, consent);
    }
    cartLink() {
      const link = this.el('a', this.t.cart, 'aws-next');
      link.href = this.root + 'cart';
      return link;
    }
    fingerprint(product, variant, allocation) {
      const plan = this.plans(product).find(item => Number(item.id) === Number(allocation?.selling_plan_id));
      return JSON.stringify({available:variant?.available,price:allocation?.price,compare:allocation?.compare_at_price,base:variant?.price,plan});
    }
    async checkout() {
      if (!this.selectionValid() || this.busy || this.uncertain || this.added) return;
      this.busy = true;
      this.next.disabled = true;
      this.back.disabled = true;
      this.next.textContent = this.t.refresh;
      this.message.textContent = '';
      let posting = false;
      try {
        const manifest = this.config.catalog.find(item => item.handle === this.product.handle);
        const fresh = await this.productFetch(manifest.url);
        const variant = fresh.variants.find(item => item.id === this.variant.id);
        const allocation = variant && this.allocations(fresh,variant).find(item => item.selling_plan_id === this.allocation.selling_plan_id);
        if (!variant?.available || !allocation || this.fingerprint(fresh,variant,allocation) !== this.fingerprint(this.product,this.variant,this.allocation)) {
          this.products = this.products.map(item => item.id === fresh.id ? fresh : item).filter(item => this.variants(item).length);
          this.product = this.variants(fresh).length ? fresh : null;
          this.variant = null;
          this.allocation = null;
          this.step = this.product ? 1 : 0;
          this.busy = false;
          this.render();
          this.message.textContent = this.t.changed;
          return;
        }
        this.next.textContent = this.t.processing;
        posting = true;
        const response = await fetch(this.root + 'cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:[{id:variant.id,quantity:1,selling_plan:allocation.selling_plan_id}]}),
          signal:AbortSignal.timeout(20000)
        });
        if (!response.ok) {
          if (response.status >= 500) throw new Error('uncertain');
          posting = false;
          const error = await response.json().catch(() => ({}));
          throw new Error(typeof error.description === 'string' ? error.description : this.t.error);
        }
        this.added = true;
        const result = await response.json();
        const added = result.items?.find(item => Number(item.variant_id || item.id) === Number(variant.id) && Number(item.selling_plan_allocation?.selling_plan?.id) === Number(allocation.selling_plan_id));
        if (!added) {
          this.uncertain = true;
          this.render();
          return;
        }
        window.location.assign(this.root + 'checkout');
      } catch (error) {
        if (posting || this.added) {
          this.uncertain = !this.added;
          this.message.textContent = this.added ? this.t.checkout_error : this.t.uncertain;
          this.content.replaceChildren(this.cartLink());
        } else {
          this.message.textContent = error.message === 'product' || error.name === 'TimeoutError' || error.name === 'TypeError' ? this.t.error : error.message;
        }
      } finally {
        this.busy = false;
        this.next.textContent = this.t.checkout;
        this.next.disabled = this.uncertain || this.added || !this.selectionValid();
        this.back.disabled = this.uncertain || this.added;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
